class Dropdown {
    private menu_dropdown: HTMLElement | null;

    constructor(private header: HTMLElement) {
        this.menu_dropdown = this.header.querySelector<HTMLElement>('.header-dropdown-menu');
        this.init();
    }

    private init() {
        this.toggle();
        this.menu();
    }

    private menu() {
        if (!this.menu_dropdown) return;

        const menus = this.menu_dropdown.querySelectorAll<HTMLElement>('.header-dropdown-inner ul.menu');

        menus.forEach(menu => {
            const items = menu.querySelectorAll('.menu-item');

            items?.forEach(item => {
                const subMenu = item.querySelector(':scope > .sub-menu, :scope > .sub-menu-wrapper');
                const siblings = item.parentElement?.children;

                if (!subMenu) return;

                item.addEventListener('click', (e) => {
                    const target = e.target as HTMLElement;

                    if (target && (target !== subMenu && !subMenu?.contains(target))) {
                        e.stopPropagation();
                        e.preventDefault();

                        item.classList.toggle('active');
                    }

                    Array.from(siblings || []).forEach(sibling => {
                        if (sibling !== item) {
                            sibling.classList.remove('active');
                        }
                    });
                });
            });
        });
    }

    private toggle() {
        const buttons = document.querySelectorAll<HTMLElement>('.header-dropdown-toggle');

        buttons.forEach(button => {
            const buttonFor = button.getAttribute('data-dropdown-toggle');
            const notFor = buttonFor == 'search' ? 'menu' : 'search';

            button.addEventListener('click', () => {
                this.close(notFor);
                this.open(buttonFor);
            })
        });
    }

    private close(name: string) {
        const dropdown = this.header.querySelector<HTMLElement>(`.header-dropdown-${name}`);
        const button = this.header.querySelector<HTMLElement>(`.header-dropdown-toggle[data-dropdown-toggle="${name}"]`);

        dropdown?.classList.remove('active');
        button?.classList.remove('active');
    }

    private open(name: string) {
        const dropdown = this.header.querySelector<HTMLElement>(`.header-dropdown-${name}`);
        const button = this.header.querySelector<HTMLElement>(`.header-dropdown-toggle[data-dropdown-toggle="${name}"]`);

        if (dropdown && dropdown.classList.contains('active')) {
            this.close(name);
        } else {
            dropdown?.classList.add('active');
            button?.classList.add('active');
        }
    }
}

window.addEventListener('load', () => {
    const header = document.querySelector<HTMLElement>('.HeaderComponent');

    if (!header) return;

    new Dropdown(header);
})